import { Capacitor } from "@capacitor/core";
import { Browser } from "@capacitor/browser";
import { Filesystem, Directory } from "@capacitor/filesystem";
import { Share } from "@capacitor/share";

export const isNative = Capacitor.isNativePlatform();
export const platform = Capacitor.getPlatform();
export const isIOSApp = platform === "ios";
export const pushEnabled = process.env.REACT_APP_PUSH_ENABLED === "true";

// Payment/portal return URLs must be real https web pages, not capacitor://localhost.
export const originUrl = () => (isNative ? (process.env.REACT_APP_WEB_URL || process.env.REACT_APP_BACKEND_URL).replace(/\/$/, "") : window.location.origin);

export async function openExternal(url) {
  if (isNative) await Browser.open({ url });
  else window.location.href = url;
}

const toBase64 = (blob) => new Promise((resolve, reject) => {
  const r = new FileReader();
  r.onloadend = () => resolve(String(r.result).split(",")[1]);
  r.onerror = reject;
  r.readAsDataURL(blob);
});

export async function saveAndShare(blob, filename) {
  const safe = filename.replace(/[^\w.-]+/g, "_");
  const { uri } = await Filesystem.writeFile({ path: safe, data: await toBase64(blob), directory: Directory.Cache });
  await Share.share({ title: safe, url: uri, dialogTitle: "Save or open file" });
}
